export default __webpack_public_path__ + "static/media/SOURCE.99c039f2.svg";